import {IconCalendar, IconCrosshair, IconFlame, IconTrophy} from "@tabler/icons-react";
import {Tabs, Tooltip} from "@ui";
import {useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import styles from "./BetbyWidgetContainer.module.css";
import BetbyWidgetFreePlay from "./BetbyWidgetFreePlay";
import BetbyWidgetHotCombos from "./BetbyWidgetHotCombos";
import BetbyWidgetPromo from "./BetbyWidgetPromo";
import BetbyWidgetTopOutrights from "./BetbyWidgetTopOutrights";

const BetbyWidgetContainer = () => {
  const {t} = useTranslation();
  const [activeTab, setActiveTab] = useState("top_match");

  // Handle tab changes with slight delay to allow proper cleanup
  const handleTabChange = useCallback(newActiveKey => {
    setActiveTab(newActiveKey);
  }, []);

  const widgetTabs = [
    {
      key: "top_match",
      label:
        activeTab === "top_match" ? (
          <span style={{fontSize: "14px", fontWeight: "500", display: "flex", alignItems: "center", gap: "6px"}}>
            {t("topEvents", "Top Events")}
          </span>
        ) : (
          <Tooltip
            title={t("topEvents", "Top Events")}
            placement="bottom"
          >
            <span style={{fontSize: "14px", fontWeight: "500", display: "flex", alignItems: "center", gap: "6px"}}>
              <IconCrosshair
                size={18}
                stroke={2}
              />
            </span>
          </Tooltip>
        ),
      children: activeTab === "top_match" ? <BetbyWidgetFreePlay key="top_match" /> : null,
    },
    {
      key: "hot_combos",
      label:
        activeTab === "hot_combos" ? (
          <span style={{fontSize: "14px", fontWeight: "500", display: "flex", alignItems: "center", gap: "6px"}}>
            {t("hotCombos", "Hot Combos")}
          </span>
        ) : (
          <Tooltip
            title={t("hotCombos", "Hot Combos")}
            placement="bottom"
          >
            <span style={{fontSize: "14px", fontWeight: "500", display: "flex", alignItems: "center", gap: "6px"}}>
              <IconFlame
                size={16}
                stroke={2}
              />
            </span>
          </Tooltip>
        ),
      children: activeTab === "hot_combos" ? <BetbyWidgetHotCombos key="hot_combos" /> : null,
    },
    {
      key: "top_outrights",
      label:
        activeTab === "top_outrights" ? (
          <span style={{fontSize: "14px", fontWeight: "500", display: "flex", alignItems: "center", gap: "6px"}}>
            {t("topOutrights", "Top Outrights")}
          </span>
        ) : (
          <Tooltip
            title={t("topOutrights", "Top Outrights")}
            placement="bottom"
          >
            <span style={{fontSize: "14px", fontWeight: "500", display: "flex", alignItems: "center", gap: "6px"}}>
              <IconCalendar
                size={16}
                stroke={2}
              />
            </span>
          </Tooltip>
        ),
      children: activeTab === "top_outrights" ? <BetbyWidgetTopOutrights key="top_outrights" /> : null,
    },
    {
      key: "promo",
      label:
        activeTab === "promo" ? (
          <span style={{fontSize: "14px", fontWeight: "500", display: "flex", alignItems: "center", gap: "6px"}}>
            {t("promoTournament", "Promo Tournament")}
          </span>
        ) : (
          <Tooltip
            title={t("promoTournament", "Promo Tournament")}
            placement="bottom"
          >
            <span style={{fontSize: "14px", fontWeight: "500", display: "flex", alignItems: "center", gap: "6px"}}>
              <IconTrophy
                size={16}
                stroke={2}
              />
            </span>
          </Tooltip>
        ),
      children: activeTab === "promo" ? <BetbyWidgetPromo key="promo" /> : null,
    },
  ];

  return (
    <div className={styles.widgetContainer}>
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={widgetTabs}
        centered
        size="small"
        className={styles.widgetTabs}
        destroyInactiveTabPane={true}
      />
    </div>
  );
};

export default BetbyWidgetContainer;
